// extracted by mini-css-extract-plugin
module.exports = {"disclaimerContainer":"DataDisclaimer_disclaimerContainer__2m3Y8"};